import React, { Component } from 'react'
import ProjectThumbnail from './ProjectThumbnail'

import { Projects } from '../../schema/types.d'

class ProjectsList extends Component<Projects.Props> {
  render() {
    return (
      <Projects.Component variables={{ searchFor: this.props.searchText }}>
        {({ loading, error, data }) => {
          if (loading) return ''
          if (error) return <div>Error</div>
          if (!data) return <div>No data!</div>
          const projects = data.projects
          const totalCount = projects.length
          return (
            <div>
              <h1 className="f6 bg-washed-blue gray mv0 pv1 ph3">
                <span className="pr3">{totalCount} Projects</span>
              </h1>
              <div className="main-box ma3 ">
                <div className="bg-white ma3 ba br2 b--black-20 flex flex-wrap w-90 justify-center center">
                  {projects.map(project => (
                    <ProjectThumbnail key={project.id} project={project} />
                  ))}
                </div>
              </div>
              <div />
            </div>
          )
        }}
      </Projects.Component>
    )
  }
}

export default ProjectsList
